import KilledView from "./KilledView";
export default KilledView